export default "__VITE_ASSET__B45FPQc$__"